import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const multipleChoiceComponentStyles: StyleRulesCallback = () => ({
  typography: {
    whiteSpace: 'pre-wrap',
    paddingTop: '20px',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: '0.875em',
    fontWeight: 'bold',
  },
  sectionContainer: {
    position: 'relative',
  },
  componentListContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
  },
  controlContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
  },
  controlContainerMd: {
    maxWidth: '150px',
  },
  controlContainerLg: {
    maxWidth: '200px',
  },
  formLabel: {
    position: 'absolute',
    marginTop: '-20px',
  },
  multiline: {
    whiteSpace: 'pre-wrap',
  },
});

export default multipleChoiceComponentStyles;
